import React from 'react';

const Security = () => {
  return (
    <div className="container py-5">
      <h1 className="mb-4 text-center">Security</h1>
      <p className="lead text-center">
        This is the Security page. Here you can provide details about security policies, measures, and information.
      </p>
      <div className="row mt-5">
        <div className="col-md-6">
          <h3>Our Security Policies</h3>
          <p>
            We prioritize the security of our platform and users. Our systems are protected using the latest
            encryption and security standards.
          </p>
        </div>
        <div className="col-md-6">
          <h3>Data Protection</h3>
          <p>
            Your personal data is secure and handled in accordance with industry-leading privacy and data protection
            policies.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Security;
